import { useStoreActions } from 'store/hooks';
import * as recurringRulesSelectors from 'store/selectors/recurringRules';
import * as recurringRulesActions from 'store/actions/recurringRules';
import { useSelectDeleteOrderLoading } from 'store/selectors/order';
import { deleteOrder } from 'store/actions/order';

export const useIndexData = () => ({
  automatedOrders: recurringRulesSelectors.useSelectAutomatedOrders(),
  automatedOrdersLoading: recurringRulesSelectors.useSelectAutomatedOrdersLoading(),
  automatedOrdersTotal: recurringRulesSelectors.useSelectAutomatedOrdersTotal(),
  deleteOrderLoading: useSelectDeleteOrderLoading(),
});

export const useActions = () =>
  useStoreActions({
    ...recurringRulesActions,
    deleteOrder,
  });
